import { render, staticRenderFns } from "./InvoicesOrPayments.vue?vue&type=template&id=898d53ce&scoped=true&"
import script from "./InvoicesOrPayments.vue?vue&type=script&lang=js&"
export * from "./InvoicesOrPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "898d53ce",
  null
  
)

export default component.exports